import { createReducer, isAnyOf } from '@reduxjs/toolkit';

import { loadersBuilder, errorBuilder, logoutBuilder } from '@modules/builders';

import buyActions from './actions';
import initialState from './state';
import type * as BuyTypes from './types';

export const buyReducer = createReducer(initialState, builder => {
  builder.addCase(buyActions.setCvv, (state, action) => {
    state.cvv = action.payload;
  });

  builder.addCase(buyActions.removeBuyToken, state => {
    delete state.buyToken;
  });

  builder.addCase(buyActions.buyRequest.fulfilled, (state, action) => {
    state.buyId = action.payload.data.id;
    state.buyStatus = action.payload.data.status;
  });

  builder.addCase(buyActions.buyRecheck.fulfilled, (state, action) => {
    state.buyId = action.payload.data.id;
    state.buyStatus = action.payload.data.status;
  });

  builder.addCase(buyActions.getBuyRate.fulfilled, (state, action) => {
    state.buyToken = action.payload.data.buy_token;
  });

  builder.addCase(buyActions.setSubtotal, (state, action) => {
    state.subtotal = action.payload;
  });

  builder.addCase(buyActions.resetBuyStatus, state => {
    if (state.buyId && state.buyStatus) {
      delete state.buyStatus;
      delete state.buyId;
    }
  });

  builder.addMatcher(
    isAnyOf(buyActions.getBuyStatus.fulfilled, buyActions.getBuyStatusPolling.fulfilled),
    (state, action) => {
      state.buyStatus = action.payload.data.status;
    }
  );

  errorBuilder('buy', builder);
  logoutBuilder(initialState, builder);
  loadersBuilder('buy', builder);
});

export { buyActions, BuyTypes };
